import React, { Component } from 'react';
import { __ } from 'i18n-for-browser';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import GoBackButton from '../elements/GoBackButton';
import GroupGameScoreRow from '../elements/GroupGameScoreRow';
import ContentContainer from "../elements/ContentContainer";

import Arrow from '../../assets/img/caret_down_grey.svg';
import GameMaterials from "../elements/GameMaterials";
import apiCall from '../apiCall';
import actions from '../../actions';
import PopupTitle from "../elements/PopupTitle";
import { dispatchUnreadPopup, getPopupDeviceDifficulty } from "../../helpers/popupHelper";

const { refreshProject } = actions.project;

class BonusPoints extends Component {
  static propTypes = {
    history: PropTypes.shape({
      goBack: PropTypes.func,
    }).isRequired,
  };
  static defaultProps = {
    desktop: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      gameScores: {},
      showBonus: false,
      showWarning: false,
      gameMaterials: [],
      isEditing: false,
    };
    this.deviceAndDifficulty = getPopupDeviceDifficulty(this.props.gameState.DefaultDifficultyId);
  }

  get game() {
    const { schoolClass } = this.props;
    if (Array.isArray(schoolClass.SchoolClassGames)) {
      const scg = schoolClass.SchoolClassGames.find(g => g.GameId === 3);
      if (scg) return scg.Game;
    }
    return {};
  }

  get submittedScores() {
    const { Rounds } = this.props.gameState;
    return !!Rounds.find(r => r.GameStates.find(gs => gs.type === 'BONUS_ASSIGNMENT'));
  }

  get assignGameScoreOnce() {
    const { project } = this.props;
    if (project.overrideBonusScores) return !!project.customAssignBonusScoreOnce;
    const settings = this.game.assignGameScoreOnce || {};
    const key = project.lite ? 'basic_lite' : project.difficulty.toLowerCase();
    // A missing key means the setting was never stored for this difficulty (LITE was
    // added after the game record). The admin checkbox shows those as enabled, so
    // only an explicit false turns the restriction off.
    return settings[key] !== false;
  }

  get allowSubmit() {
    const rounds = this.props.gameState.Rounds;
    if (!rounds || rounds.length === 0) return false;
    const round = rounds[rounds.length - 1]; // Use current round
    if (!round) return false;
    return (round.state.startsWith('SIMULATION_') || round.state === 'END');
  }

  componentWillMount() {
    if (!this.game.id) return;
    this.fetchGeneralMaterials();

    const { dispatch, project, schoolClass } = this.props;
    dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvtextraopdrachten_T1' : 'mlbvtextraopdrachten_T1'), dispatch);

    const gameScores = {};
    if (this.submittedScores) {
      schoolClass.Groups.forEach((group) => {
        const bonus = this.getRoundOneBonusPointsForGroup(group);
        if (bonus && (bonus.points > 0 || bonus.globas > 0)) {
          gameScores[group.id] = bonus;
        }
      });
      this.setState({ gameScores });
    }
  }


  gameScoreUpdate = (groupId, value) => {
    const { gameScores } = this.state;
    gameScores[groupId] = JSON.parse(value);
    if (typeof gameScores[groupId] !== 'object') delete gameScores[groupId];
    this.setState({
      gameScores,
    });
  };

  fetchGeneralMaterials = () => {
    const { project, schoolClass } = this.props;
    apiCall(`/generalMaterial/${schoolClass.LanguageId}/${project.DefaultDifficultyId}/${this.game.id}`)
      .then((generalMaterials) => {
        this.setState({ gameMaterials: generalMaterials });
      });
  };

  submitGameScores = () => {
    if (!this.allowSubmit) {
      this.setState({ showWarning: true });
      const _this = this;
      setTimeout(() => {
        _this.setState({ showWarning: false });
      }, 5000);
      return false;
    }
    apiCall('/simulatiespel/bonusAssignmentScores', this.state.gameScores, 'POST')
      .then(() => {
        this.props.dispatch(refreshProject());
        this.setState({ isEditing: false });
      });
  };

  getRoundOneBonusPointsForGroup = (group) => {
    if (!group.Rounds || group.Rounds.length === 0) return { points: 0, globas: 0 };
    const round1 = group.Rounds.find(r => r.roundNumber === 1);
    const gameState = round1 ? round1.GameStates.find(gs => gs.type === 'BONUS_ASSIGNMENT') : null;
    if (gameState) {
      return {
        globas: gameState.globas,
        points: gameState.points,
      };
    }
    return { points: 0, globas: 0 };
  };

  render() {
    const { schoolClass, project } = this.props;
    if (!this.game.id) {
      return null;
    }
    const { assignGameScoreOnce } = this;
    return (
      <div className={this.props.desktop ? 'portal-home portal-verdelen classleader-portal darkBckg' : 'portal-verdelen classleader-portal darkBckg'}>
        <div className={'container'}>
          <div className={'title-block'}>
            <GoBackButton history={this.props.history} />
            <PopupTitle popupId={`${this.deviceAndDifficulty}bvtextraopdrachten_1`} tag={'h3'} />
            <p>{__('sim_bonuspunten')}</p>
          </div>
          <div className={'column-portal'}>
            <div className={'title-container'}>
              <PopupTitle popupId={`mlbvtextraopdrachten_1`} tag={'h3'} />
            </div>
            {this.props.desktop ? null :
              <ContentContainer style={{ marginBottom: '20px', padding: '15px' }} onClick={() => this.state.showBonus ? this.setState({ showBonus: false }) : this.setState({ showBonus: true })}>
                <div className={'title-container bekijk-bonusopdrachten-container'}>
                  <h3>{__('sim_bekijk_bonusopdrachten')}</h3>

                  <img
                    src={Arrow}
                    className={this.state.showBonus ? 'turn arrow-down' : 'arrow-down'}
                    alt='arrow-down' />
                </div>
              </ContentContainer>
            }
            <div className={'bonus-materials-wrapper' + (this.state.showBonus || this.props.desktop ? ' active' : '')}>
              <GameMaterials items={this.state.gameMaterials} />
            </div>
          </div>
          <div className={'column-portal'}>
            <div className={'group-rows-container'}>
              <div className="title-container">
                <PopupTitle popupId={`${this.deviceAndDifficulty}bvtverdiendebonuspunten`} tag={'h3'} />
              </div>
              {
                schoolClass.Groups.map((group) => {
                  return (
                    <GroupGameScoreRow
                      key={group.id}
                      bonus={true}
                      text={__(group.name)}
                      color={group.GroupTheme.color}
                      score={this.state.gameScores[group.id] || {}}
                      editable={!this.submittedScores || this.state.isEditing}
                      isPoints={true}
                      gameScores={(project.overrideBonusScores && project.customBonusScores && project.customBonusScores.length ? project.customBonusScores : this.game.GameScores).filter((gs) => {
                        const { gameScores } = this.state;
                        const difficultyFilter = project.lite ? (gs.DifficultyId === null && !!gs.lite) : (gs.DifficultyId === project.DefaultDifficultyId);

                        if (!assignGameScoreOnce) {
                          return difficultyFilter;
                        }

                        const used = Object.keys(gameScores).find((key) => {
                          // LITE scores are stored without globas, so normalise both
                          // sides before comparing: null/undefined must match 0.
                          return Number(gameScores[key].points) === Number(gs.points)
                            && Number(gameScores[key].globas || 0) === Number(gs.globas || 0)
                            && parseInt(key, 10) !== group.id;
                        });

                        return difficultyFilter && !used;
                      })}
                      onChange={(value) => {
                        this.gameScoreUpdate(group.id, value);
                      }}
                    />
                  )
                })
              }
            </div>
            <div>
              {!this.submittedScores || this.state.isEditing ? (
                <button className={(!this.allowSubmit ? 'disabled' : '')} style={{ pointerEvents: 'all' }} onClick={this.submitGameScores}>
                  <span>{__('sim_opslaan')}</span>
                </button>
              ) : (
                <button style={{ pointerEvents: 'all', backgroundColor: '#e8ac1b' }} onClick={() => this.setState({ isEditing: true })}>
                  <span>{__('sim_bonuspunten_aanpassen')}</span>
                </button>
              )}
              {!this.allowSubmit && this.state.showWarning ? (
                <p style={{ marginTop: '10px', fontWeight: 'bold', color: 'white', textShadow: '0 0px 4px rgba(0, 0, 0, 0.5)', textAlign: 'center' }}>{__('sim_bonuspunten_toekennen_uitleg')}</p>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(({ project, schoolClass, gameState }) => ({
  project,
  schoolClass,
  gameState
}))(BonusPoints);



// WEBPACK FOOTER //
// ./src/components/routes/BonusPoints.js